import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import HostelPage from '../../views/HostelPage/';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';

const GLOBAL = require('../../Globals');

class Floors extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			 idd : '',
			hlist : [],
			loading: false,
			_message : '',
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			//value : '',
			alertClass :'',
			//_redirect : false,
			posts: []
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onupdateSubmit = this.onupdateSubmit.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		//this.handleChange = this.handleChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
			this.getdata();
		
	}
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	
	onClick(e){
		
		document.getElementById("flrform").reset();
	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) { 		
			PostData('hostel/removefloor',this.state).then((result) => {
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Floor Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Floor',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	

	
	/* set value to react select 
	handleChange(value){
		
		this.setState({value});
		console.log(this.state.value);
		
	}*/
	onBack(){
		
		this.setState({idd : ''});
		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.getfrdata();
	}
	
	getfrdata(){
		
		GetData('hostel/getfloorbyid/'+this.state.idd).then((result) => {
			let res = result;
			if(res){
				this.setState({
					hname : res[0]['hostel'],
					hflrname : res[0]['name'],
					hroomscount : res[0]['noofrooms'],
					hroomscharge : res[0]['incharge']
				});
			}
		});
	}
	
	onupdateSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		if(this.state.idd){
			PostData('hostel/updatefloor',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Floor Updated Successfully!..',
						alertClass:'alert alert-success',
						idd : ''
					});
					this.getdata();
				}
				else{
					this.setState({
						_message:'Invalid Key',
						alertClass:'alert alert-danger'
					});
					this.getdata();
				}
				$("#showLoader").hide();
			});
		
		}
	
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		if(this.state!=''){
			PostData('hostel/addfloor',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Floor Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("flrform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
					document.getElementById("flrform").reset();
					this.getdata();
				}
				$("#showLoader").hide();
			});
		}
	
	}
	
	componentWillMount() {
		 
		this.getdata();
		this.gethostel();
	}
	
	/** get  Hostel List **/
	gethostel(){
		
		GetData('hostel/gethostel').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					hlist : responseJson
				});
				this.getdata();
			}
		});
	}
	
	
	getdata(){
		this.setState({loading:true});
		GetData('hostel/getfloors').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					loading:false
				});
			}
		});
	}
	
	
  render() {
	  
	var hnames = this.state.hlist;
	
	/** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	if(this.state.idd!=''){
		
		$("#editflr").show();
		$("#addflr").hide();
	}
	else{
		
		$("#editflr").hide();
		$("#addflr").show();
	}
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.posts.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
	  return <tr key = {item}>
								<td width="20">{i+1}</td>
								<td >{item.hname}</td>
								<td >{item.name}</td>
								<td >{item.noofrooms}</td>
								<td >{item.incharge}</td>
								<td >
									<button name="edithw" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} ><i className="fa fa-edit"></i></button>
									&nbsp;&nbsp;
									<button name="removeann" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
								</td>
							</tr>;
		
	});
	
    return (
		<div>
		  <HostelPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="5" id="addflr">
					<Card>
					  <form action="" method="post" role="form" id="flrform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Add Floor</strong>
							
						</CardHeader>
						<CardBody>
							<Row>
							 <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Hostel<span className="text-danger">*</span></Label>
								  <select name="hname" className="form-control"  onChange={this.onChange} required id="hname">
										<option value="">Select Hostel</option>
										{
											hnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								</select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Name<span className="text-danger">*</span></Label>
								  <Input type="text" name="hflrname" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Rooms<span className="text-danger">*</span></Label>
								  <Input type="number" name="hroomscount" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Floor inCharge<span className="text-danger">*</span></Label>
								  <Input type="text" name="hroomscharge" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="5" id="editflr">
					<Card>
					  <form action="" method="post" role="form" id="flrupform" encType="multipart/form-data" onSubmit={this.onupdateSubmit} >
						<CardHeader>
							<strong>Update Floor</strong>
							<Button outline color="primary" className="btn-right" onClick={this.onBack}>Add</Button>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Hostel<span className="text-danger">*</span></Label>
								  <select name="hname" className="form-control"  onChange={this.onChange} value={this.state.hname} required id="hname">
										<option value="">Select Hostel</option>
										{
											hnames.map(function (item) {
												return <option value={item.id }>{item.name}</option>;
											})
										}
								</select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Name<span className="text-danger">*</span></Label>
								  <Input type="text" name="hflrname" required onChange={this.onChange} value={this.state.hflrname} />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Rooms<span className="text-danger">*</span></Label>
								  <Input type="number" name="hroomscount" required onChange={this.onChange} value={this.state.hroomscount} />
								</FormGroup>
							  </Col>
							   <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Floor inCharge<span className="text-danger">*</span></Label>
								  <Input type="text" name="hroomscharge" required onChange={this.onChange} value={this.state.hroomscharge} />
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				   <Col md="7">
				   <Card>
				   <CardHeader>
							<strong>Floors</strong>
							
						</CardHeader>
					<CardBody>
					<Col md="12">
					<Table responsive bordered>
						<thead>
							<tr>
								<th width="20">S.No</th>
								<th >Hostel Name</th>
								<th >Floor Name</th>
								<th >Rooms</th>
								<th >Incharge</th>
								<th >Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.loading ?  <tr><td colSpan="6"><center><Loader /></center></td></tr> : renderTodos}
						</tbody>
					</Table>
					</Col>
					<Col md="4">
					  <Pagination
								 activePage={this.state.activePage}
								 itemsCountPerPage={this.state.todosPerPage}
								 pageRangeDisplayed={3}
								 totalItemsCount={this.state.posts.length}
								 onChange={this.handlePageChange}
								/>
					  </Col>
					  <Col md="2">
					   <select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					  </Col>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Floors;


// WEBPACK FOOTER //
// ./src/hostel/HostelList/floors.js